// Auto-generated by generate-page-aggregations.cjs
// Do not edit this file manually - it will be overwritten
// Run 'node scripts/generate-page-aggregations.cjs' to regenerate

import { Components, Theme } from '@mui/material/styles';

// ============================================================================
// PAGE THEME IMPORTS
// ============================================================================

// No page themes found

// ============================================================================
// EXPORTED AGGREGATIONS
// ============================================================================

/**
 * Array of all page theme objects.
 * Pass this to mergePageThemes() from @ncino/pax-ui
 *
 * @example
 * import { mergePageThemes } from '@ncino/pax-ui';
 * import { allPageThemes } from './generated/page-aggregations';
 * import { appThemeOptions } from './app/app.theme';
 *
 * const theme = mergePageThemes(allPageThemes, appThemeOptions);
 */
export const allPageThemes: Components<Theme>[] = [
  
];

// ============================================================================
// PAGE LOCALES
// ============================================================================
//
// Page locales are NOT aggregated here. Register each page's translations at
// module load so they ship in the page's own code-split chunk:
//
//   import { registerPageTranslations } from '@ncino/pax-ui';
//   import dashboardEn from './locales/en_US.json';
//
//   registerPageTranslations('dashboard', { en_US: dashboardEn });
//
// Then consume them with useTranslation('dashboard').

// ============================================================================
// METADATA
// ============================================================================

export const pageAggregationMeta = {
  pageCount: 0,
  themeCount: 0,
  supportedLocales: ["en_US"],
};
